<template>
  <!-- 投诉管理 -->
  <div>
    <div class="clearfix">
      <Form @submit.native.prevent :model="formData" label-position="left" class="mytable-titleBox">
        <div class="clearfix">
          <FormItem label="投诉人昵称:" class="fl mytable-title" :label-width="86">
            <Input v-model="formData.complaint_username" placeholder="请输入投诉人昵称"></Input>
          </FormItem>
          <FormItem label="投诉人手机号:" class="fl mytable-title" :label-width="110">
            <Input v-model="formData.complaint_phone" placeholder="请输入投诉人手机号"></Input>
          </FormItem>

          <div class="fl checkReset">
            <Button type="primary" class="fl" @click="handleQuery">查询</Button>
            <Button class="fl" @click="handleReset">重置</Button>
          </div>
        </div>
        <div class="line"></div>

        <RadioGroup
          v-model.trim="formData.complaint_status"
          type="button"
          class="fl mr20 mt24"
          @on-change="handleRefundchange"
        >
          <Radio :label="empty">全部</Radio>
          <Radio :label="0">待处理</Radio>
          <Radio :label="1">已处理</Radio>
        </RadioGroup>
        <FormItem label="日期范围:" class="fl mytable-title ml24 mt24" :label-width="72">
          <DatePicker
            class="w240"
            v-model.trim="date"
            type="daterange"
            @on-change="handleDateChange"
            format="yyyy-MM-dd"
            placeholder="开始日期 ~ 结束日期"
          ></DatePicker>
        </FormItem>
      </Form>
    </div>

    <Table
      @on-selection-change="handleTableChange"
      :loading="tableLoading"
      class="mt24"
      :columns="columns"
      :data="tableData"
    ></Table>
    <Page
      class="mt24"
      :total="total"
      :current="page_num"
      show-elevator
      show-sizer
      show-total
      @on-page-size-change="handleSizeChange"
      @on-change="handlePageChange"
    />
    <!-- 回复弹窗 -->
    <Modal
      v-model="modalVisibile"
      width="724"
      :mask-closable="false"
      title="查看明细"
      @on-cancel="handleCancel"
    >
      <Form @submit.native.prevent ref="modalForm" :model="modalForm" label-position="top">
        <div
          style="font-size:14px;color:#909599;margin-bottom:24px;word-break:break-all;word-wrap:break-word;"
        >
          举报内容
          <span style="color:#2E3133;">{{modalForm.complaintContent}}</span>
        </div>

        <div style="font-size:14px;color:#909599;margin-bottom:24px;">
          <p v-show="modalForm.complaintImageList.length">图片</p>
          <div class="tsImg">
            <img
              v-for="(item,index) in modalForm.complaintImageList"
              :key="index"
              :src="item"
              alt
              @click="clickImg(index)"
            />
          </div>

          <div style="font-size:14px;color:#2E3133;margin-top:24px;">
            <FormItem label="客服回复" :label-width="58">
              <Input
                v-model="modalForm.reply_content"
                style="width: 288px;margin-left:-56px;"
                type="textarea"
                placeholder="请输入要回复至用户的内容"
                :disabled="isClick"
              ></Input>
            </FormItem>
          </div>
        </div>
      </Form>
      <div slot="footer">
        <Button type="text" @click="handleCancel">取消</Button>
        <Button
          :loading="modalLoading"
          type="primary"
          @click="handleModalSubmit"
          :disabled="isClick"
        >提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import mixins from "@/mixins/page";
export default {
  name: "user_manage",
  mixins: [mixins],
  data() {
    return {
      isClick: true,
      //保存是否显示的数组
      isShowArr: [],
      // isShenhe: Number(localStorage.getItem("isShenhe")),
      selectedVal: [],
      empty: "",
      modalLoading: false,
      modalForm: {
        complaintImageList: [],
        reply_content: ""
      },
      modalForm1: {
        complaintImageList: [],
        reply_content: ""
      },
      modalVisibile: false,
      isAdmin: Number(localStorage.getItem("sa")), //1 超级管理员  0作者
      // isAdmin: 0,
      vipData: [],
      date: [],
      formData: {
        complaint_status: ""
      },
      formData1: {
        complaint_status: ""
      },
      tableData: [],
      columns: [
        {
          title: "投诉人昵称",
          align: "center",
          key: "complaint_username"
        },
        {
          title: "手机号",
          align: "center",
          key: "complaint_phone",
          render:(h,params)=>{
            var phone =params.row.complaint_phone?params.row.complaint_phone.substr(0, 3) + "****" +params.row.complaint_phone.substr(7):'无';                  
            return h('span',phone)
          }
        },
        {
          title: "时间",
          align: "center",
          key: "createtime"
        },
        {
          title: "状态",
          align: "center",
          key: "complaint_status",
          render: (h, params) => {
            var status = "";
            if (params.row.complaint_status) {
              status = "已处理";
            } else {
              status = "待处理";
            }
            return h(
              "span",
              {
                class: {
                  yellow: params.row.complaint_status ? false : true
                }
              },
              status
            );
          }
        },
        {
          title: "管理员",
          key: "cust_operator_username",
          align: "center"
        },
        {
          title: "举报明细",
          align: "center",
          key: "age",
          render: (h, params) => {
            return h(
              "span",
              {
                class: {
                  btn_edit: true
                },
                on: {
                  click: () => this.handleCheck(params)
                }
              },
              "查看"
            );
          }
        }
      ]
    };
  },
  mounted() {
    this.handleQuery();
  },
  methods: {
    clickImg(index) {
      //
      this.$pic.init(this.modalForm.complaintImageList,index);
    },
    handleTableChange(val) {
      this.selectedVal = val;
    },
    //回复提交
    handleModalSubmit() {
      if (this.modalForm.id) {
        this.modalLoading = true;
        this.$api
          .complaintReplay({
            reply_content: this.modalForm.reply_content,
            id: this.modalForm.id
          })
          .then(res => {
            if (res.code === 0) {
              this.modalVisibile = false;
              this.$Message.success(res.msg);
              this.getTableData();
              this.handleCancel();
            } else {
              this.$Message.error(res.msg);
            }
            this.modalLoading = false;
          });
      }
    },
    //查看
    handleCheck(params) {
      this.modalForm.id = params.row.id;
      if (params.row.complaint_status) {
        this.isClick = true;
      } else {
        this.isClick = false;
      }

      this.$api
        .complaintDetail({
          ...this.modalForm
        })
        .then(res => {
          if (res.code === 0) {
            this.modalForm.complaintContent = res.data.complaintContent;
            this.modalForm.complaintImageList = res.data.complaintImageList;
            this.modalForm.reply_content = res.data.reply_comment;
            this.modalVisibile = true;
          } else {
            this.$Message.error(res.msg);
          }
        });
    },
    handlePostStatus(param) {
      //样式
      this.tableData.map(item => {
        //操作状态
        if (item.id === param.id) {
          item.is_show = param.is_show ? 0 : 1;
        }
        //选中状态保持不变
        if (this.selectedVal.length) {
          this.selectedVal.map(item1 => {
            if (item1.id === item.id) {
              item._checked = true;
            }
          });
        } else {
          item._checked = false;
        }
        return item;
      });

      let flag = true;
      let paramData = {
        id: param.id,
        is_show: param.is_show === 0 ? 1 : 0
      };

      if (this.isShowArr.length === 0) {
        this.isShowArr.push(paramData);
      } else {
        this.isShowArr.map((item, index) => {
          //已经选择过，组数中有
          if (item.id === param.id) {
            // console.log("重复");
            if (this.isShowArr[index].is_show) {
              this.isShowArr[index].is_show = 0;
            } else {
              this.isShowArr[index].is_show = 1;
            }
            flag = false;
          }
        });
        if (flag) {
          this.isShowArr.push(paramData);
        }
      }

      // this.$api.commentIsShow(paramData).then(res => {
      //   // this.$Message.success('操作成功')
      //   this.tableData.map(item => {
      //     //操作状态
      //     if (item.id === param.id) {
      //       item.is_show = paramData.is_show;
      //     }
      //     //选中状态保持不变
      //     if (this.selectedVal.length) {
      //       this.selectedVal.map(item1 => {
      //         if (item1.id === item.id) {
      //           item._checked = true;
      //         }
      //       });
      //     }

      //     return item;
      //   });

      //   // this.getTableData()
      // });
    },
    handleCancel() {
      this.modalVisibile = false;
      this.modalForm = Object.assign({}, this.modalForm1);
    },
    //日期范围
    handleDateChange(val) {
      if (val[0]) {
        this.formData.start_time = val[0] + " 00:00:00";
        this.formData.end_time = val[1] + " 23:59:59";
      } else {
        this.formData.start_time = "";
        this.formData.end_time = "";
      }
      this.handleQuery();
    },
    handleRefundchange() {
      this.handleQuery();
    },
    handleReset() {
      this.formData = Object.assign({}, this.formData1);
      this.date = [];

      this.handleQuery();
    },
    handleQuery() {
      this.page_num = 1;
      this.getTableData();
    },
    getTableData() {
      this.tableLoading = true;
      this.$api
        .complaintList({
          ...this.formData,
          page_num: this.page_num,
          page_size: this.page_size
        })
        .then(res => {
          if (res.code === 0) {
            this.tableData = res.data.list;
            this.total = res.data.total_row;
          } else {
            this.$Message.error(res.msg);
          }
          this.tableLoading = false;
        });
    }
  }
};
</script>
<style scoped lang="less">
.tsImg img {
  width: 150px;
  height: 150px;
  border-radius: 4px;
  margin-right: 12px;
  margin-top: 12px;
  cursor: pointer;
}
/deep/ .table_pic {
  width: 35px;
  height: 35px;
  border-radius: 100%;
  display: block;
  margin: 0 auto;
}
/deep/ .btn_true {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: url("../../assets/images/true.png") no-repeat;
  -webkit-background-size: 16px 16px;
  background-size: 16px 16px;
  cursor: pointer;
}
/deep/ .btn_false {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: url("../../assets/images/false.png") no-repeat;
  -webkit-background-size: 16px 16px;
  background-size: 16px 16px;
  cursor: pointer;
}
/deep/.cursor {
  cursor: pointer;
}
/deep/textarea.ivu-input {
  height: 84px;
}
</style>
